import type { QueryFunctionContext } from "@tanstack/query-core"
import type { AxiosResponse } from "axios"

import { axiosClient } from "$/http"

import { EParticipantByIdQueryKey, EParticipantByIdQueryUrl, EUserQueryUrl } from "@/3514/config"
import type { IUserDto, IUserParticipantDto } from "@/3514/types"

async function userQueryFetcher(): Promise<IUserDto> {
    const { data }: AxiosResponse<IUserDto> = await axiosClient.get(EUserQueryUrl())

    return data
}

async function participantByIdQueryFetcher({
    queryKey
}: QueryFunctionContext<ReturnType<typeof EParticipantByIdQueryKey>>): Promise<IUserParticipantDto> {
    const { data }: AxiosResponse<IUserParticipantDto> = await axiosClient.get(
        EParticipantByIdQueryUrl(queryKey[1] as number)
    )

    return data
}

export { userQueryFetcher, participantByIdQueryFetcher }
